import { render, staticRenderFns } from "./TermosDeUso.vue?vue&type=template&id=43ea131e"
import script from "./TermosDeUso.vue?vue&type=script&lang=js"
export * from "./TermosDeUso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports